import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import { ReactComponent as PlusIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-add.svg';

interface AddNewCardButtonProps {
  isAddCardDisabled: boolean;
  handleAddNewCard: () => void;
}

export const AddNewCardButton = (props: AddNewCardButtonProps) => {
  const { isAddCardDisabled, handleAddNewCard } = props;
  const { t } = useTranslation();

  return (
    <button
      type='button'
      className={`flex flex-row gap-[8px] py-[16px] pl-[24px] items-center w-full hover:bg-bw02 ${isAddCardDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      onClick={handleAddNewCard}
      disabled={isAddCardDisabled}
    >
      <div
        className='border-dashed rounded-full border-[1px] border-bw04 h-[40px] w-[40px] p-[8px] flex flex-col'
        id='link-new-account-button-text'
      >
        <PlusIcon width='22px' height='22px' />
      </div>
      <div
        className='font-metricRMedium leading-[146%] text-[16px] text-left'
        data-tooltip-id='link-new-account-button-text'
        data-tooltip-content={t('TRANSACTIONS_FACELIFT.SYNC_CARD.LINK_LINIT')}
        data-tooltip-place='bottom'
        data-tooltip-hidden={!isAddCardDisabled}
        data-tooltip-offset={24}
      >
        {t('TRANSACTIONS_FACELIFT.SYNC_CARD.SYNC_NEW_CARD')}
      </div>
      <Tooltip id='link-new-account-button-text' />
    </button>
  );
};
